module.exports = __webpack_public_path__ + "static/secure-icons-dd25af457e227a6ef950326a3702e01f.svg";